import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import {KeysPipe} from './key.pipe';
import { DisplayProperties } from './DisplayProperties-pipe';
import { DisplayCamelCasePipe } from './display-camel-case.pipe';
import { GetPastDueBannerText } from './pastDueBannerTextPipe';

@NgModule({
  declarations: [KeysPipe, DisplayProperties, DisplayCamelCasePipe, GetPastDueBannerText],
  imports: [CommonModule],
  exports: [KeysPipe, DisplayProperties,DisplayCamelCasePipe, GetPastDueBannerText]
})

export class MainPipe { }
